const DIGEST_TASKS_KEY = 'platform-assistant-digest-tasks'

function todayKey(): string {
	return new Date().toISOString().slice(0, 10)
}

function loadStore(): Record<string, boolean> {
	try {
		const raw = localStorage.getItem(DIGEST_TASKS_KEY)
		if (!raw) return {}
		const parsed = JSON.parse(raw)
		return parsed && typeof parsed === 'object' ? parsed : {}
	} catch {
		return {}
	}
}

function saveStore(store: Record<string, boolean>): void {
	try {
		localStorage.setItem(DIGEST_TASKS_KEY, JSON.stringify(store))
	} catch {
		// ignore
	}
}

export function digestTaskKey(category: string, title: string, siteId?: string): string {
	return `${todayKey()}::${category}::${siteId ?? 'global'}::${title}`
}

export function isDigestTaskDone(key: string): boolean {
	return Boolean(loadStore()[key])
}

export function setDigestTaskDone(key: string, done: boolean): void {
	const store = loadStore()
	if (done) store[key] = true
	else delete store[key]
	saveStore(store)
}

export function countDigestTasksDone(keys: string[]): { done: number; total: number } {
	const store = loadStore()
	const total = keys.length
	const done = keys.filter((key) => store[key]).length
	return { done, total }
}

export function digestTaskKeysFromItems(
	items: Array<{ category: string; title: string; site_id?: string }>,
): string[] {
	return items.map((item) => digestTaskKey(item.category, item.title, item.site_id))
}
